<template lang="pug">

    form.ui.form(v-on:submit.prevent='submit()')

        step-indicator(v-bind:activeStep='5')

        .ui.top.attached.header Allgemeine Angaben:
        .ui.bottom.attached.segment
            general-information-form(
                ref="generalInformation"
                v-bind:company='companyModel'
                v-model='model'
            )

        .ui.top.attached.header Lieferadressen:
        .ui.bottom.attached.segment
            shipping-addresses-form(
                ref='shippingAddressesForm'
                v-bind:company-model='companyModel'
                v-bind:country-models='countryModels'
                v-bind:person-models='personModels'
                v-bind:shipping-addresses='shippingAddressModels'
                v-model='addresses'
            )

        wizard-navigation(v-on:back="back()" nextLabel="Speichern")

</template>

<script>
    import { object_to_collection as format_fields_object_to_collection } from '@/utils/field'
    import store from '@/store'
    import GeneralInformationForm from '@/components/products/forms/GeneralInformationForm'
    import ShippingAddressesForm from '@/components/products/forms/ShippingAddressesForm'
    import StepIndicator from '@/components/products/StepIndicator'
    import WizardNavigation from '@/components/products/WizardNavigation'

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {
        name: 'products-create-step5-view',

        async beforeRouteEnter(to, from, next) {
            if (store.getters['products/draft'].type === undefined) {
                next({ name: 'products/create' })
            }

            // Unternehms-ID aus Entwurf laden
            const companyId = store.getters['products/draft'].company

            await Promise.all([

                // Unternehmen laden
                store.dispatch('companies/loadOne', { id: companyId }),

                // Laender laden
                store.dispatch('countries/loadAll'),

                // Lieferadressen des Unternehmens laden
                store.dispatch('addresses/loadAllByCompanyIdAndIsShippingAddress', { companyId }),

                // Personen des Unternehmens laden
                store.dispatch('persons/loadAllByCompanyId', { companyId })

            ])

            next()
        },

        created() {
            this.$scrollTo('body')
        },

        components: { GeneralInformationForm, ShippingAddressesForm, StepIndicator, WizardNavigation },

        computed: {

            addresses: {
                get() { return this.model.shippingAddresses },
                set(value) { this.updateValue('shippingAddresses', value) },
            },

            companyModel() {
                return store.getters['companies/byId'](this.model.company)
            },

            countryModels() {
                return store.getters['countries/all']
            },

            isInvalid() {
                return this.$refs.generalInformation.$v.$invalid ||
                    this.$refs.shippingAddressesForm.$invalid
            },

            model: {
                get() { return this.$store.getters['products/draft'] || {} },
                set(model) { this.$store.commit('products/REPLACE_DRAFT', { draft: model }) }
            },

            personModels() {
                return this.$store.getters['persons/allByCompanyId'](this.companyModel.id) || []
            },

            shippingAddressModels() {
                return this.$store.getters['addresses/allByCompanyIdAndIsShippingAddress'](this.companyModel.id)
            },

        },

        methods: {

            back() {
                this.$router.push({
                    name: 'products/create/step4',
                    params: this.$route.params
                })
            },

            submit() {
                // Embedded-Forms als "submitted" markieren
                this.$refs.generalInformation.$v.$touch()
                this.$refs.shippingAddressesForm.$touch()

                // Pruefen ob alle Formular valide sind
                if (this.isInvalid) {
                    this.$scrollToAndFocus('.field.error')
                    return
                }

                // Auflagen und Formularfelder/Produktspezifikationen in Format bringen
                const model    = { ...this.model }
                model.variants = model.variants.map(variantModel => {
                    return {
                        ...variantModel,
                        fields: format_fields_object_to_collection(variantModel.fields),
                        printings: [
                            variantModel.printing1,
                            variantModel.printing2,
                            variantModel.printing3,
                            variantModel.printing4,
                            variantModel.printing5,
                        ]
                    }
                })

                // Leere Belegkopien entfernen (Empfänger allein zählt nicht als "angefordert")
                const isSpecimenCopyEmpty = copy => copy == null || (copy.amount == null && copy.address == null)
                if (isSpecimenCopyEmpty(model.specimenCopy)) {
                    delete model.specimenCopy
                }
                if (isSpecimenCopyEmpty(model.specimenCopyInternal)) {
                    delete model.specimenCopyInternal
                }

                // Speichern
                this.$store.dispatch('products/create', { model }).then(() => {
                    this.$router.push({ name: 'products' })
                    this.$growl.success('Produkt wurde erstellt')
                }).catch(e => {
                    this.$growl.fatal('Produkt konnte nicht erstellt werden. Bitte an den Support wenden', e)
                })
            },

            updateValue(target, value) {
                this.model = { ...this.model, [target]: value }
            }

        }

    }

</script>
